<template>
  <UApp :locale="uiLocale">
    <ImpersonationBanner />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <BookingRequestModal />
  </UApp>
</template>

<script setup lang="ts">
import { fa_ir } from '@nuxt/ui/locale'
import ImpersonationBanner from '~/components/ImpersonationBanner.vue'
import BookingRequestModal from '~/components/blocks/BookingRequestModal.vue'
 
const route = useRoute()
const privateRoute = computed(() => /^\/(?:admin|auth|builder|dashboard|onboarding|patient|support|virtual-visit)(?:\/|$)/.test(route.path))

useHead(() => ({
  meta: privateRoute.value ? [{ name: 'robots', content: 'noindex,nofollow' }] : [],
}))

/** Persian RTL locale on auth, dashboard, patient portal, onboarding, admin; public site / builder keep default. */
const uiLocale = computed(() =>
  /^\/(auth|dashboard|onboarding|admin|support|patient)/.test(route.path) ? fa_ir : undefined,
)
</script>
